import React, { useCallback, useState } from 'react';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Text } from '@televet/kibble-ui/build/components/Text';

interface FeedbackProps {
  onPositiveFeedback: () => void;
  onNegativeFeedback: () => void;
  label?: string;
  thanksMessage?: string;
  onFeedbackSubmitted?: () => void;
}

const Feedback: React.FC<FeedbackProps> = ({
  onPositiveFeedback,
  onNegativeFeedback,
  label = 'How was this?',
  thanksMessage = 'Thanks for your feedback!',
  onFeedbackSubmitted,
}) => {
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);

  const handlePositiveFeedback = useCallback((): void => {
    onPositiveFeedback();
    setFeedbackSubmitted(true);
    onFeedbackSubmitted?.();
  }, [onPositiveFeedback, onFeedbackSubmitted]);

  const handleNegativeFeedback = useCallback((): void => {
    onNegativeFeedback();
    setFeedbackSubmitted(true);
    onFeedbackSubmitted?.();
  }, [onNegativeFeedback, onFeedbackSubmitted]);

  return (
    <Flex alignItems="center">
      <Text as="p" size="sm" variant="subtle" mr={1}>
        {feedbackSubmitted ? thanksMessage : label}
      </Text>
      {!feedbackSubmitted && (
        <>
          <Button iconName="thumbsUp" size="sm" variant="ghostNeutral" onClick={handlePositiveFeedback} />
          <Button iconName="thumbsDown" size="sm" variant="ghostNeutral" onClick={handleNegativeFeedback} />
        </>
      )}
    </Flex>
  );
};

export default Feedback;
